export default __webpack_public_path__ + "static/Exceptional_Kibble-21d1f50cc48eff85e69e7bb0e5a88574.png";